<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bRnm2W/tc-custom/9780795317361.jpg?1705692586257" alt="This image is the cover for the book Monkey Wrench Gang"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Monkey Wrench Gang
      </h1>
      <p class="bookDescription body article font2">
        <b>A motley crew of saboteurs wreaks havoc on the corporations destroying America’s Western wilderness in this “wildly funny, infinitely wise” classic (<i>The Houston Chronicle</i>).</b><br/>  <br/> When George Washington Hayduke III returns home from war in the jungles of Southeast Asia, he finds the unspoiled West he once knew has been transformed. The pristine lands and waterways are being strip mined, dammed up, and paved over by greedy government hacks and their corrupt corporate coconspirators. And the manic, beer-guzzling, rabidly antisocial ex-Green Beret isn’t just getting mad. Hayduke plans to get even.<br/>  <br/> Together with a radical feminist from the Bronx; a wealthy, billboard-torching libertarian MD; and a disgraced Mormon polygamist, Hayduke’s ready to stick it to the Man in the most creative ways imaginable. By the time they’re done, there won’t be a bridge left standing, a dam unblown, or a bulldozer unmolested from Arizona to Utah.<br/>  <br/> Edward Abbey’s most popular novel, <i>The Monkey Wrench Gang </i>is an outrageous romp with ultra-serious undertones that is as relevant today as it was in the early days of the environmental movement. The author who Larry McMurtry (<i>Lonesome Dove</i>) once dubbed “The Thoreau of the American West” has written a true comedic classic with brains, heart, and soul that more than justifies the call from the <i>Los Angeles Times Book Review</i> that we should all “praise the earth for Edward Abbey!”<br/><br/> “Mixes comedy and chaos with enough chase sequences to leave you hungering for more.”—<i>The San Francisco Chronicle</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edward Abbey
      </h2>
      
      <p class="authorDescription body article">&amp;lt;p&amp;gt;Edward Abbey spent most of his life in the American Southwest. He was the author of numerous works of fiction and nonfiction, including the celebrated &amp;lt;em&amp;gt;Desert Solitaire&amp;lt;/em&amp;gt;, which decried the waste of America&amp;#8217;s wilderness, and the novel &amp;lt;em&amp;gt;The Monkey Wrench Gang&amp;lt;/em&amp;gt;, the title of which is still in use today to describe groups that purposefully sabotage projects and entities that degrade the environment. Abbey was also one of the country&amp;#8217;s foremost defenders of the natural environment. He died in 1989.&amp;lt;/p&amp;gt;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      RosettaBooks, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?762841d0